// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logout`
};

const de_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Abmelden`
};

const es_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar sesión`
};

const fr_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Déconnexion`
};

const fi_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Kirjaudu ulos`
};

const hi_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `लॉगआउट`
};

const ja_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `ログアウト`
};

const nl_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Uitloggen`
};

const pt_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Terminar sessão`
};

const ro_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Deconectare`
};

const th_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `ออกจากระบบ`
};

const ur_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `لاگ آؤٹ`
};

const zh_hant1_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `登出`
};

const da_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Log ud`
};

const it_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Disconnetti`
};

const vn_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Đăng xuất`
};

const ko_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `로그아웃`
};

const tr_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Çıkış yap`
};

const lv_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Iziet`
};

const ar_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `تسجيل الخروج`
};

const bs_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Odjavi se`
};

const sl_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Odjava`
};

const id_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Keluar`
};

const sv_widget_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logga ut`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_logout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_logout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_logout", locale)
	if (locale === "en") return en_widget_logout(inputs)
	if (locale === "de") return de_widget_logout(inputs)
	if (locale === "es") return es_widget_logout(inputs)
	if (locale === "fr") return fr_widget_logout(inputs)
	if (locale === "fi") return fi_widget_logout(inputs)
	if (locale === "hi") return hi_widget_logout(inputs)
	if (locale === "ja") return ja_widget_logout(inputs)
	if (locale === "nl") return nl_widget_logout(inputs)
	if (locale === "pt") return pt_widget_logout(inputs)
	if (locale === "ro") return ro_widget_logout(inputs)
	if (locale === "th") return th_widget_logout(inputs)
	if (locale === "ur") return ur_widget_logout(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_logout(inputs)
	if (locale === "da") return da_widget_logout(inputs)
	if (locale === "it") return it_widget_logout(inputs)
	if (locale === "vn") return vn_widget_logout(inputs)
	if (locale === "ko") return ko_widget_logout(inputs)
	if (locale === "tr") return tr_widget_logout(inputs)
	if (locale === "lv") return lv_widget_logout(inputs)
	if (locale === "ar") return ar_widget_logout(inputs)
	if (locale === "bs") return bs_widget_logout(inputs)
	if (locale === "sl") return sl_widget_logout(inputs)
	if (locale === "id") return id_widget_logout(inputs)
	if (locale === "sv") return sv_widget_logout(inputs)
	return "widget_logout"
};